module.exports = __webpack_public_path__ + "img/_mexico.87c26646.png";